import { render, staticRenderFns } from "./role_list.vue?vue&type=template&id=01afbb21&scoped=true&"
import script from "./role_list.vue?vue&type=script&lang=js&"
export * from "./role_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01afbb21",
  null
  
)

export default component.exports